<template>
  <!-- The word under the pointer: its dictionary form and, here, what it renders. No request needed. -->
  <div v-if="hover && hover.word.lexeme" class="hover-card" :style="{ left: `${hover.x}px`, top: `${hover.y + 6}px` }">
    <div class="line">
      <span :class="fontOf(hover.word.lexeme)">{{ hover.word.lexeme.headword }}</span>
      <span v-if="hover.word.lexeme.gloss" class="gloss">{{ hover.word.lexeme.gloss }}</span>
    </div>
    <div v-if="hover.word.counterpart.length" class="line counterpart">
      <span class="arrow">{{ isRendered(hover.word.lexeme.language) ? '←' : '→' }}</span>
      <span v-for="c in hover.word.counterpart" :key="c.key" :class="fontOf(c)">{{ c.headword }}</span>
      <span v-if="!hover.word.confident" class="unconfirmed">unconfirmed</span>
    </div>
    <div class="hint">click for the index</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { isRendered } from '@/components/lemmas/renderer/wordLayer'
import { font } from '../format'
import { indexState } from '../indexState'

export default defineComponent({
  name: 'HoverCard',
  setup() {
    const hover = computed(() => indexState.hover)
    return { hover, fontOf: font, isRendered }
  },
})
</script>

<style lang="scss" scoped>
@import '@/_colors';

.hover-card {
  position: fixed;
  z-index: 40;
  transform: translateX(-50%);
  max-width: 22rem;
  padding: 0.5rem 0.75rem;
  background: $surface;
  border: 1px solid $border-strong;
  border-radius: 4px;
  box-shadow: $frame-shadow;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.line {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-size: 1.1rem;
}

.gloss,
.hint,
.unconfirmed {
  color: $text-light;
  font-size: 0.75rem;
}

.unconfirmed {
  font-style: italic;
}

.arrow {
  color: $interactive;
}
</style>
